import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CustomerVouGroupsServices from '@src/services/customerVouGroups.services';

export const getAllProducts = createAsyncThunk(
  'getAllProducts',
  async (body, { rejectWithValue }) => {
    try {
      return await CustomerVouGroupsServices.getAllProducts();
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const getActiveProducts = createAsyncThunk(
  'getActiveProducts',
  async (_, { getState, rejectWithValue }) => {
    try {
      let customerId = getState()?.user.selectedUserId;

      if (!customerId) {
        customerId = await getState()?.customer.selectedCustomer.customerId;
      }

      const result = await CustomerVouGroupsServices.getAllActiveProducts({
        activeCustomerId: customerId,
      });
      return result;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  allProducts: [],
  activeProductList: [],
};

export const customerVouGroupsSlice = createSlice({
  name: 'customerVouGroups',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllProducts.fulfilled, (state, action) => {
      state.allProducts = action?.payload?.data;
    });
    builder.addCase(getActiveProducts.fulfilled, (state, action) => {
      state.activeProductList = action?.payload?.data || [];
    });
  },
});

export default customerVouGroupsSlice.reducer;
